import config from '../../../config';
import Request from '../../Request';

export default function getPriceEstimate(values, onSuccess, onFailure) {
  return Request.post(`${config.apiUrl}/public/reservations/price_estimate`, values, onSuccess, onFailure);
}